export const auctionListType = {
  SEARCH: 'SEARCH',
  MY_VEHICLES: 'MY_VEHICLES',
  MY_BIDS: 'MY_BIDS',
};
